import React, { ReactElement, ForwardedRef } from 'react';
import ButtonInternal from '@mui/material/Button';
import FormatService from '../../services/format-service';
import useStylesButton from './button.styles';

const Button: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLButtonElement>,
): ReactElement => {
  const COLOR_PRIMARY: ThemeColor = 'primary';
  const COLOR_SECONDARY: ThemeColor = 'secondary';
  const BUTTON_VARIANT_CONTAINED: ButtonVariant = 'contained';
  const BUTTON_VARIANT_TEXT: ButtonVariant = 'text';
  const BUTTON_TYPE_BUTTON: ButtonType = 'button';

  const {
    isActive,
    isDefault,
    isDisabled,
    isText,
    isNarrow,
    isExtended,
    isMediumSize,
    isFullWidth,
    variant,
    className,
    onClick,
    children,
    ...custom
  } = props;

  const { classes } = useStylesButton();

  const isContainedButton: boolean = !variant || variant === BUTTON_VARIANT_CONTAINED;
  const isTextButton: boolean = isText || variant === BUTTON_VARIANT_TEXT;

  const defaultClassName: string | undefined = isDefault ? classes.buttonDefault : undefined;
  const activeClassName: string | undefined = isActive && isContainedButton ? classes.buttonActive : undefined;
  const activeTextClassName: string | undefined = isActive && isTextButton ? classes.buttonActiveText : undefined;
  const narrowClassName: string | undefined = isNarrow ? classes.buttonNarrow : undefined;
  const mediumClassName: string | undefined = isMediumSize ? classes.buttonMedium : undefined;
  const largeClassName: string | undefined = isExtended ? classes.buttonLarge : undefined;
  const fullWidthClassName: string | undefined = isFullWidth ? classes.buttonFullWidth : undefined;
  const disabledClassName: string | undefined = isDisabled ? classes.buttonDisabled : undefined;

  return (
    <ButtonInternal
      disabled={isDisabled}
      ref={ref}
      type={BUTTON_TYPE_BUTTON}
      color={isActive ? COLOR_SECONDARY : COLOR_PRIMARY}
      variant={variant || (isText ? BUTTON_VARIANT_TEXT : BUTTON_VARIANT_CONTAINED)}
      className={FormatService.formatClassNames(
        classes.button, activeClassName, activeTextClassName, narrowClassName, mediumClassName, largeClassName,
        fullWidthClassName, defaultClassName, className,
      )}
      classes={{
        disabled: disabledClassName,
      }}
      onClick={onClick}
      {...custom}
    >
      {children}
    </ButtonInternal>
  );
}));

export default Button;
